<template>
  <div class="fill-height additional-details-layout">
    <v-sheet
      tile
      class="fill-height"
    >
      <v-row
        no-gutters
        class="fill-height"
      >
        <v-col>
          <v-container
            fluid
            class="px-6"
          >
            <v-btn
              rounded
              depressed
              color="white"
              small
              class="mb-2"
              @click="onCloseDrawer"
            >
              <v-icon
                color="primary"
                class="mr-1"
              >
                mdi-close-circle
              </v-icon>
              <span class="primary--text text-decoration-underline">Close</span>
            </v-btn>
            <h2 class="mb-3">
              <slot name="header" />
            </h2>
            <p>
              <slot name="sub-header" />
            </p>
            <slot name="content" />
          </v-container>

          <slot name="additional-content" />
          <v-container
            v-if="backBtn"
            fluid
            class="px-6 mt-6"
          >
            <v-btn
              outlined
              rounded
              large
              color="primary"
              class="outlined-2"
              @click="onCloseDrawer"
            >
              <v-icon
                color="primary"
                class="mr-1"
                small
              >
                mdi-arrow-left
              </v-icon>
              <span class="font-weight-medium">Back to results</span>
            </v-btn>
          </v-container>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: 'details-layout',
  props: {
    backBtn: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    onCloseDrawer () {
      this.$emit('close-drawer');
    },
  },
};
</script>

<style scoped lang="scss">
.additional-details-layout {
  background-color: #fff;
}
</style>
